"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopInfoBlock = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("../../../UI/Typography"));
const Types_1 = require("Types");
const svg_components_1 = require("@/assets/svg-components");
const Modal_1 = __importDefault(require("../../../UI/Modal"));
const ModalCard_1 = __importDefault(require("./ModalCard"));
const Hooks_1 = require("@/Hooks");
const ProductCatalogLanguageSelector_1 = __importDefault(require("@/Components/ProductCatalogLanguageSelector"));
const POSSIBLE_BLOCK_HEIGHT = 230;
const ONE_ROW_HEIGHT = 70;
const TopInfoBlock = ({ title, description, backHref, showBackButton, imageUrl, isListingPage, hasLanguageSelector, alt }) => {
    const { width } = (0, Hooks_1.useWindowSize)();
    const listRef = (0, react_1.useRef)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [showMoreButton, setShowMoreButton] = (0, react_1.useState)(false);
    const { t } = (0, Hooks_1.useTranslate)();
    const { isDesktop, isMobile } = (0, Hooks_1.useDevice)();
    (0, react_1.useEffect)(() => {
        const list = listRef.current;
        if (!list)
            return;
        // scrollHeight is the full content height, regardless of the current max-height
        setShowMoreButton(list.scrollHeight > (isDesktop ? POSSIBLE_BLOCK_HEIGHT : ONE_ROW_HEIGHT));
    }, [description, width, isDesktop]);
    (0, react_1.useEffect)(() => {
        const list = listRef.current;
        if (!list)
            return;
        if (!showMoreButton) {
            list.style.maxHeight = '100%';
        }
        else if (!isOpen) {
            list.style.maxHeight = `${isDesktop ? POSSIBLE_BLOCK_HEIGHT : ONE_ROW_HEIGHT}px`;
        }
        else {
            if (!isDesktop) {
                list.style.display = 'flex';
            }
            list.style.maxHeight = list.scrollHeight + 100 + 'px';
        }
    }, [isOpen, width, showMoreButton, isDesktop]);
    return (react_1.default.createElement(styled.Container, null,
        react_1.default.createElement(styled.TitleContainer, null,
            showBackButton && (react_1.default.createElement(styled.ButtonContainer, { href: backHref },
                react_1.default.createElement(styled.ArrowIcon, null))),
            react_1.default.createElement(styled.Title, null,
                react_1.default.createElement(Typography_1.default, { type: isDesktop ? Typography_1.Types.H2 : Typography_1.Types.H3, as: 'h1' }, title),
                hasLanguageSelector && !isMobile && react_1.default.createElement(ProductCatalogLanguageSelector_1.default, null))),
        react_1.default.createElement(styled.InfoContainer, null,
            react_1.default.createElement(styled.ListContainer, { makeFlex: !isOpen && !isDesktop, col: 12, md: imageUrl ? 7 : 12 },
                react_1.default.createElement(styled.List, { ref: listRef },
                    react_1.default.createElement(styled.GradientOverlay, { showGradient: showMoreButton && !isOpen }),
                    description && (react_1.default.createElement(styled.Description, { type: isListingPage ? Typography_1.Types.BODY_1 : Typography_1.Types.INTRODUCTORY_TEXT, dangerouslySetInnerHTML: { __html: description }, greyColor: !isDesktop && !isOpen })),
                    !isDesktop && isListingPage && imageUrl && (react_1.default.createElement(styled.ImageContainer, { mobileView: !isDesktop, onClick: () => imageUrl && setIsModalOpen(true), imageUrl: imageUrl },
                        react_1.default.createElement(styled.Image, { src: imageUrl, alt: alt }),
                        react_1.default.createElement(styled.SearchIconContainer, null,
                            react_1.default.createElement(svg_components_1.SearchPlusIcon, null))))),
                showMoreButton && (react_1.default.createElement(styled.Button, { mobileView: !isDesktop, variant: Types_1.ButtonVariants.LINK_BUTTON, onClick: () => setIsOpen(prev => !prev) }, isOpen
                    ? t('/haldex/product_page/button_labels/show_less')
                    : t('/haldex/product_page/button_labels/read_more'))),
                isModalOpen && (react_1.default.createElement(Modal_1.default, null,
                    react_1.default.createElement(ModalCard_1.default, { closeModal: () => setIsModalOpen(false), image: imageUrl })))),
            isDesktop && isListingPage && imageUrl && (react_1.default.createElement(styled.ImageContainer, { mobileView: !isDesktop, onClick: () => imageUrl && setIsModalOpen(true), imageUrl: imageUrl },
                react_1.default.createElement(styled.Image, { src: imageUrl, alt: alt }),
                react_1.default.createElement(styled.SearchIconContainer, null,
                    react_1.default.createElement(svg_components_1.SearchPlusIcon, null)))))));
};
exports.TopInfoBlock = TopInfoBlock;
exports.default = (0, react_1.memo)(exports.TopInfoBlock);
